import { render, staticRenderFns } from "./AclListRulesTab.vue?vue&type=template&id=780ca03f&scoped=true&"
import script from "./AclListRulesTab.vue?vue&type=script&lang=js&"
export * from "./AclListRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./AclListRulesTab.vue?vue&type=style&index=0&id=780ca03f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ca03f",
  null
  
)

export default component.exports